<template>
    <div>
        <div class="panel-tag mt-3" v-if="commissionItems.length == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-else class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 lock-header" style="max-height:calc(100vh - 480px); overflow-y: scroll">
                    <!-- <div class="fs-xs fw-300 text-right pt-2 pb-2">
                        <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed mr-2" @click="showAllDetails">{{isExpand == 'Expand' ? $t('button_link.expand_details') : $t('button_link.collapse_details')}} </button>
                    </div> -->
                    <b-table id="salesItemTable" small striped hover bordered :fields="fields" :items="commissionItems">
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(title)="data">
                            <a class="fw-500 text-primary link" title="View Details" :id="'salesItems_' + data.item.completedID" @click="showDetails($event)">{{data.item.item.title}}</a>
                            <div class="mt-1 salesItemDetail" style="display: none;">
                                <b-table-simple class="table table-sm table-hover table-bordered table-striped">
                                    <b-tr>
                                        <b-th>{{$t('table.header.date')}}</b-th>
                                        <b-td>{{convertTimestampToDateTime(data.item.createDate)}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.receipt_number')}}</b-th>
                                        <b-td>
                                            <a class="fw-400 text-primary link" title="View Receipt" @click="generateReceipt(data.item.salesID)">
                                                {{insertLeadingZero(data.item.receiptID)}}
                                                <i class="fal fa-print"></i>
                                            </a>
                                        </b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.outlet')}}</b-th>
                                        <b-td>{{getOutletName(data.item.outletID)}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('subMenu.my_salon_member') + $t('table.header.name')}}</b-th>
                                        <b-td>{{data.item.member.displayName}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.contact')}}</b-th>
                                        <b-td>
                                            <a class="fw-400 text-primary link" title="Edit Member">
                                                {{data.item.member.mobile}}
                                                <i class="fal fa-pen"></i>
                                            </a>
                                        </b-td>    
                                    </b-tr>
                                </b-table-simple>    
                            </div>
                        </template>
                        <template #cell(date)="data">{{convertTimestampToDateTime(data.item.createDate)}}</template>
                        <template #cell(outlet)="data">{{getOutletName(data.item.outletID)}}</template>
                        <template #cell(receipt)="data">
                            <a class="fw-400 text-primary link" title="View Receipt" @click="generateReceipt(data.item.salesID)">
                                {{insertLeadingZero(data.item.receiptID)}}
                                <i class="fal fa-print"></i>
                            </a>
                        </template>
                        <template #cell(price)="data">{{formatPrice(data.item.price)}}</template>
                        <template #cell(discount)="data">{{formatPrice(data.item.discount)}}</template>
                        <template #cell(outstandings)="data">{{formatPrice(data.item.outstandings)}}</template>
                        <template #cell(subtotal)="data">{{formatPrice(data.item.subtotal)}}</template>

                        <!-- <template #cell(set1)="data">{{formatPrice(data.item.e1)}}</template> -->
                        <template #cell(effort1)="data">{{formatPrice(data.item.effort1)}}</template>
                        <template #cell(cmss1)="data">{{formatPrice(data.item.cmss1)}}</template>
                        <template #cell(percent1)="data">{{formatPrice(data.item.percent1)}}</template>
                        <template #cell(originalFee1)="data">{{formatPrice(data.item.originalFee1)}}</template>
                        <template #cell(fee1)="data">{{formatPrice(data.item.fee1)}}</template>

                        <template #cell(effort2)="data">{{formatPrice(data.item.effort2)}}</template>
                        <template #cell(cmss2)="data">{{formatPrice(data.item.cmss2)}}</template>
                        <template #cell(percent2)="data">{{formatPrice(data.item.percent2)}}</template>
                        <template #cell(originalFee2)="data">{{formatPrice(data.item.originalFee2)}}</template>
                        <template #cell(fee2)="data">{{formatPrice(data.item.fee2)}}</template>

                        <template #cell(effort3)="data">{{formatPrice(data.item.effort3)}}</template>
                        <template #cell(cmss3)="data">{{formatPrice(data.item.cmss3)}}</template>
                        <template #cell(percent3)="data">{{formatPrice(data.item.percent3)}}</template>
                        <template #cell(originalFee3)="data">{{formatPrice(data.item.originalFee3)}}</template>
                        <template #cell(fee3)="data">{{formatPrice(data.item.fee3)}}</template>

                        <template #cell(effort4)="data">{{formatPrice(data.item.effort4)}}</template>
                        <template #cell(cmss4)="data">{{formatPrice(data.item.cmss4)}}</template>
                        <template #cell(percent4)="data">{{formatPrice(data.item.percent4)}}</template>
                        <template #cell(originalFee4)="data">{{formatPrice(data.item.originalFee4)}}</template>
                        <template #cell(fee4)="data">{{formatPrice(data.item.fee4)}}</template>

                        <template #cell(edit)="data">
                            <a class="link d-block text-primary" title="Edit Staff Commission" @click="showEditCommission(
                                data.item.item.type, data.item.completedID, data.item.item.title, data.item.orderID, data.item.receiptID, data.item.outletID, getSubTotal(data.item.price, data.item.discount, data.item.outstandings), data.item.staffs
                            )">
                                <i class="fal fa-pen"></i>
                            </a>
                        </template>

                        <template #custom-foot>
                            <b-tr>
                                <b-td colspan="8" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</b-td>
                                <!-- <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.price)}}</b-td> -->
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.discount)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.outstandings)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.subtotal)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500"></b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.effort1)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500"></b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.cmss1)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.originalFee1)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.fee1)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500"></b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.effort2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500"></b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.cmss2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.originalFee2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.fee2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4"></b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.effort3)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4"></b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.cmss3)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.originalFee3)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.fee3)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4"></b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.effort4)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4"></b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.cmss4)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.originalFee4)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500" v-show="showStaff3and4">{{formatPrice(objTotalData.fee4)}}</b-td>
                            </b-tr>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {calculateSalesReportTotal, getSubTotal} from '@/assets/js/dashboard/salonReport/salonReport.js'
import {getOutletName, handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
import {formatPrice, insertLeadingZero} from '@/assets/js/dashboard/utilities.js'
export default {
    name: "salesDate",
    props:{
        commissionSalesItem: { type: Array }
    },
    data(){
        return{
            commissionItems: [], 
            objTotalData: {},
            isExpand: "Expand",
            showStaff3and4: false,
        }
    },
    computed:{
        fields(){
            let list = [
                {key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "date", label: 'Date', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "outlet", label: 'Outlet', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "receipt", label: "Receipt Number", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "mobile", label: 'Mobile', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "voucher", label: "Item", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "_itemType", label: "Type", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "_paymentMethod", label: "Payment", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "discount", label: "Discount", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "outstandings", label: "Outstanding", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "subtotal", label: "Subtotal", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                // {key: "section", label: "Section", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
            ]

            let staffCount = this.showStaff3and4 ? 4 : 2
            for(let i=1; i<=staffCount; i++) {
                list.push(
                    {key: "Staff" + i, label: "Staff " + i, thClass: 'thead-themed align-middle', tdClass: 'align-middle bg-staff' + i, sortable: false},
                    // {key: "e" + i, label: "Set", thClass: 'thead-themed align-middle', tdClass: 'align-middle bg-staff' + i, sortable: true},
                    {key: "effort" + i, label: "Effort", thClass: 'thead-themed align-middle', tdClass: 'align-middle bg-staff' + i, sortable: true},
                    {key: "percent" + i, label: "Commission Percent (%)", thClass: 'thead-themed align-middle', tdClass: 'align-middle bg-staff' + i, sortable: true},
                    {key: "cmss" + i, label: "Commission", thClass: 'thead-themed align-middle', tdClass: 'align-middle bg-staff' + i, sortable: true},
                    {key: "originalFee" + i, label: "Original HOF", thClass: 'thead-themed align-middle', tdClass: 'align-middle bg-staff' + i, sortable: true},
                    {key: "fee" + i, label: "Hands On Fee", thClass: 'thead-themed align-middle', tdClass: 'align-middle bg-staff' + i, sortable: true},
                )
            }

            list.push(
                {key: "edit", label: "Action", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
            )

            list.push(
                {key: "_error", label: "Error", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
            )

            return list
        },
        editFields(){
            return[
                { key: "index", label: "#"},
                { key: "editStaff", label: this.$i18n.t('table.header.staff')},
                { key: "editEffort", label: this.$i18n.t('table.header.effort')},
                { key: "editPercentage", label:  this.$i18n.t('table.header.effort_percentage')},
                { key: "editFee", label: this.$i18n.t('table.header.fee')}
            ]
        },
    },
    methods:{
        getOutletName(id){
            return getOutletName(id, JSON.parse(this.$store.state.outlets));
        },
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24);
        },
        formatPrice(p){
            if(p === '' || p === null || p === undefined) {
                return ''
            }
            return formatPrice(p);
        },

        sortTable(a, b, key){
            if(key == "title"){
                var aTitle = a.item.title
                var bTitle = b.item.title
                return aTitle.localeCompare(bTitle);
            }else if(key == 'subTotal'){
                var aTotal = getSubTotal(a.price, a.discount, a.outstandings, a.tax.taxType, a.tax.tax)
                var bTotal = getSubTotal(b.price, b.discount, b.outstandings, a.tax.taxType, a.tax.tax)
                return aTotal - bTotal
            }
            return false
        },
        updateTable(items, filterObj){
            this.commissionItems = items
            this.getTotalData(this.commissionItems);
            this.setExportData(items, filterObj)
        },
        getTotalData(item){
            this.showStaff3and4 = false

            this.objTotalData = {}//calculateSalesReportTotal(item)
            for(let temp of item) {
                if (temp['StaffID3']) {
                    this.showStaff3and4 = true
                }

                for (let key in temp) {
                    if (['price', 'discount', 'outstandings', 'subtotal', 
                        'effort1', 'cmss1', 'originalFee1', 'fee1',
                        'effort2', 'cmss2', 'originalFee2', 'fee2',
                        'effort3', 'cmss3', 'originalFee3', 'fee3',
                        'effort4', 'cmss4', 'originalFee4', 'fee4',
                    ].includes(key)) {
                        this.objTotalData[key] = this.objTotalData[key] || 0
                        this.objTotalData[key] += parseFloat(temp[key]) || 0
                    }
                }
            }
            this.$emit('setTotalData', this.objTotalData)
        },
        getSubTotal(price, discount, outstandings, taxType, tax){
            return getSubTotal(price, discount, outstandings, taxType, tax)
        },

        showAllDetails(){   
            var isExpand = false;
            if(this.isExpand == "Expand"){
                isExpand = true;
                this.isExpand = "Collapse"
            }else{
                isExpand = false;
                this.isExpand = "Expand"
            }
            var detailsContainer = document.getElementById("salesItemTable").querySelectorAll(".salesItemDetail");
            for(var i=0; i<detailsContainer.length; i++){
                if(isExpand){
                    if(detailsContainer[i].style.display == 'none'){
                        detailsContainer[i].style.display = 'block'
                    }
                }else{
                    if(detailsContainer[i].style.display == 'block'){
                        detailsContainer[i].style.display = 'none'
                    }
                }
            }
        },
        showDetails(e){
            var link = e.target.id;
            var detailsDiv = document.getElementById(link).nextSibling;
            detailsDiv.style.display = detailsDiv.style.display == 'none' ? 'block' : 'none';

            var hideCount = 0;
            var detailsContainer = document.getElementById("salesItemTable").querySelectorAll(".salesItemDetail");

            for(var i=0; i<detailsContainer.length; i++){
                if(detailsContainer[i].style.display == 'none'){
                    hideCount++
                }
            }

            this.isExpand = hideCount == this.commissionItems.length ? "Expand" : "Collapse"
        },

        generateReceipt(salesID){
            let $vm = this
            const QUERY_STRING = "/" + salesID + "/receipt";
            const url =  this.$api.REPORT_SALES + QUERY_STRING;

            this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                if(response.status == 200){
                    var path = response.data.path;
                    window.open(path, '_blank');
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            }) 
        },

        setExportData(group, filterObj) {
            var exportData = []
            for (var k = 0; k < group.length; k++) {
                var obj = {
                    '#': k + 1,
                    'Date': this.convertTimestampToDateTime(group[k]['createDate']),
                    'Outlet': this.getOutletName(group[k]['outletID']),
                    'Receipt': this.insertLeadingZero(group[k]['receiptID']),
                    'Mobile': group[k]['mobile'] || '',
                    'Item': group[k]['voucher'] || '',
                    'Type': group[k]['_itemType'] || '',
                    'Payment': group[k]['_paymentMethod'] || '',
                    'Discount': this.formatPrice(group[k]['discount']),
                    'Outstanding': this.formatPrice(group[k]['outstandings']),
                    'Subtotal': this.formatPrice(group[k]['subtotal']),
                    // 'Section': group[k]['section'],
                    'Staff 1': group[k]['Staff1'] || '',
                    'Set 1': this.formatPrice(group[k]['e1'] || ''),
                    'Effort 1': this.formatPrice(group[k]['effort1'] || ''),
                    'Commission Percentage 1': this.formatPrice(group[k]['percent1']),
                    'Commission 1': this.formatPrice(group[k]['cmss1'] || ''),
                    'Original HOF 1': this.formatPrice(group[k]['originalFee1']),
                    'Hands-On Fee 1': this.formatPrice(group[k]['fee1']),
                    'Staff 2': group[k]['Staff2'] || '',
                    'Effort 2': this.formatPrice(group[k]['effort2'] || ''),
                    'Commission Percentage 2': this.formatPrice(group[k]['percent2']),
                    'Commission 2': this.formatPrice(group[k]['cmss2'] || ''),
                    'Original HOF 2': this.formatPrice(group[k]['originalFee2']),
                    'Hands-On Fee 2': this.formatPrice(group[k]['fee2']),
                    'Staff 3': group[k]['Staff3'] || '',
                    'Effort 3': this.formatPrice(group[k]['effort3'] || ''),
                    'Commission Percentage 3': this.formatPrice(group[k]['percent3']),
                    'Commission 3': this.formatPrice(group[k]['cmss3'] || ''),
                    'Original HOF 3': this.formatPrice(group[k]['originalFee3']),
                    'Hands-On Fee 3': this.formatPrice(group[k]['fee3']),
                    'Staff 4': group[k]['Staff4'] || '',
                    'Effort 4': this.formatPrice(group[k]['effort4'] || ''),
                    'Commission Percentage 4': this.formatPrice(group[k]['percent4']),
                    'Commission 4': this.formatPrice(group[k]['cmss4'] || ''),
                    'Original HOF 4': this.formatPrice(group[k]['originalFee4']),
                    'Hands-On Fee 4': this.formatPrice(group[k]['fee4']),
                }

                exportData.push(obj)
            }

            exportData.push({
                '#': 'Total',
                'Discount': this.formatPrice(this.objTotalData['discount']),
                'Outstanding': this.formatPrice(this.objTotalData['outstandings']),
                'Subtotal': this.formatPrice(this.objTotalData['subtotal']),
                'Staff 1': '',
                'Effort 1': this.formatPrice(this.objTotalData['effort1']),
                'Commission 1': this.formatPrice(this.objTotalData['cmss1']),
                'Original HOF 1': this.formatPrice(this.objTotalData['originalFee1']),
                'Hands-On Fee 1': this.formatPrice(this.objTotalData['fee1']),
                'Staff 2': '',
                'Effort 2': this.formatPrice(this.objTotalData['effort2']),
                'Commission 2': this.formatPrice(this.objTotalData['cmss2']),
                'Commission Percentage 2': this.formatPrice(this.objTotalData['percent2']),
                'Original HOF 2': this.formatPrice(this.objTotalData['originalFee2']),
                'Hands-On Fee 2': this.formatPrice(this.objTotalData['fee2']),
                'Staff 3': '',
                'Effort 3': this.formatPrice(this.objTotalData['effort3']),
                'Commission 3': this.formatPrice(this.objTotalData['cmss3']),
                'Commission Percentage 3': this.formatPrice(this.objTotalData['percent3']),
                'Original HOF 3': this.formatPrice(this.objTotalData['originalFee3']),
                'Hands-On Fee 3': this.formatPrice(this.objTotalData['fee3']),
                'Staff 4': '',
                'Effort 4': this.formatPrice(this.objTotalData['effort4']),
                'Commission 4': this.formatPrice(this.objTotalData['cmss4']),
                'Commission Percentage 4': this.formatPrice(this.objTotalData['percent4']),
                'Original HOF 4': this.formatPrice(this.objTotalData['originalFee4']),
                'Hands-On Fee 4': this.formatPrice(this.objTotalData['fee4']),
            })

            var strDate = moment(filterObj.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + 'Sales'
            var exportHeaders = [
                this.$msg.REPORT.HEADER + 'Sales',
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet == "all" ? this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) : this.getOutletName(filterObj.outlet)),
                " "];
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                exportHeaders = ''
            }
            var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName,
                exportFields: this.exportFields
            }
            this.$emit('setExportData', data)
        },

        showEditCommission(type, completedID, title, orderID, receiptID, outletID, price, staffs) {
            this.$emit('showEditCommission', type, completedID, title, orderID, receiptID, outletID, price, staffs)
        },
    },
    mounted(){
        let $vm = this;
        $vm.commissionItems = $vm.commissionSalesItem
        $vm.getTotalData($vm.commissionItems);
    }
}
</script>
<style scoped>
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}

.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}

.disabled-td{
    background: #e9e9e9;
}

::-webkit-scrollbar {
    background-color: #f5f5f5;
    border-radius: 10px;
    height: 10px;
    width: 10px;
}
::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
}
</style>

<style>
.lock-header {
    overflow: -moz-scrollbars-vertical; 
    overflow-y: scroll;
    max-height: 75vh;
}

.lock-header thead {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 11;
}

/* .lock-header td:nth-child(1) {
    position: sticky;
    left: 0;
	background-color: #fff;
    z-index: 10;
}

.lock-header tr:nth-of-type(odd) td:nth-child(1) {
    background-color: #f4f4f4;
} */
</style>